import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Login = lazy(() => import('../pages/login/page'));
const UserDashboard = lazy(() => import('../pages/user/dashboard/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const UserAttendance = lazy(() => import('../pages/user/attendance/page'));
const AdminAttendance = lazy(() => import('../pages/admin/attendance/page'));
const UserWork = lazy(() => import('../pages/user/work/page'));
const AdminWork = lazy(() => import('../pages/admin/work/page'));
const UserAnnouncements = lazy(() => import('../pages/user/announcements/page'));
const AdminAnnouncements = lazy(() => import('../pages/admin/announcements/page'));
const UserSupport = lazy(() => import('../pages/user/support/page'));
const AdminSupport = lazy(() => import('../pages/admin/support/page'));
const UserConsultation = lazy(() => import('../pages/user/consultation/page'));
const AdminConsultation = lazy(() => import('../pages/admin/consultation/page'));
const UserManuals = lazy(() => import('../pages/user/manuals/page'));
const AdminManuals = lazy(() => import('../pages/admin/manuals/page'));
const AdminUsers = lazy(() => import('../pages/admin/users/page'));
const AdminReports = lazy(() => import('../pages/admin/reports/page'));
const AdminBusinessCards = lazy(() => import('../pages/admin/business-cards/page'));
const AdminSalesReports = lazy(() => import('../pages/admin/sales-reports/page'));
const AdminSchedule = lazy(() => import('../pages/admin/schedule/page'));
const AdminMessages = lazy(() => import('../pages/admin/messages/page'));
const AdminProjects = lazy(() => import('../pages/admin/projects/page'));
const AdminDailyReports = lazy(() => import('../pages/admin/daily-reports/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/user/dashboard',
    element: <UserDashboard />,
  },
  {
    path: '/user/attendance',
    element: <UserAttendance />,
  },
  {
    path: '/user/work',
    element: <UserWork />,
  },
  {
    path: '/user/announcements',
    element: <UserAnnouncements />,
  },
  {
    path: '/user/support',
    element: <UserSupport />,
  },
  {
    path: '/user/consultation',
    element: <UserConsultation />,
  },
  {
    path: '/user/manuals',
    element: <UserManuals />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/attendance',
    element: <AdminAttendance />,
  },
  {
    path: '/admin/work',
    element: <AdminWork />,
  },
  {
    path: '/admin/announcements',
    element: <AdminAnnouncements />,
  },
  {
    path: '/admin/support',
    element: <AdminSupport />,
  },
  {
    path: '/admin/consultation',
    element: <AdminConsultation />,
  },
  {
    path: '/admin/manuals',
    element: <AdminManuals />,
  },
  {
    path: '/admin/users',
    element: <AdminUsers />,
  },
  {
    path: '/admin/reports',
    element: <AdminReports />,
  },
  {
    path: '/admin/business-cards',
    element: <AdminBusinessCards />,
  },
  {
    path: '/admin/sales-reports',
    element: <AdminSalesReports />,
  },
  {
    path: '/admin/schedule',
    element: <AdminSchedule />,
  },
  {
    path: '/admin/messages',
    element: <AdminMessages />,
  },
  {
    path: '/admin/projects',
    element: <AdminProjects />,
  },
  {
    path: '/admin/daily-reports',
    element: <AdminDailyReports />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
